import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder, fwa} from "./libs/binder";
import { constants } from "./modules/module";
import { checkedAllFunction } from "./modules/checkedAllFunction";
import { header } from "./modules/header";
import { animationOnScroll } from "./modules/animationOnScroll";
import { articleSlider } from "./modules/articleSlider";
import { goToAnchor } from "./modules/goToAnchor";
import { accordion } from "./modules/accordion";
import { videoSlider } from "./modules/videoSlider";
import { seriesVideoSlider } from "./modules/seriesVideoSlider";
import { bufferLink } from "./modules/bufferLink";
import { openClose } from "./modules/openClose";
import { pictureSlider } from "./modules/pictureSlider";
import { tabFunction } from "./modules/tabFunction";
import { customSelect } from "./modules/customSelect";
import { viewMoreFunction } from "./modules/viewMoreFunction";
import {popups} from "./modules/popups";
import {gallerySlider} from "./modules/gallerySlider";
import {scheduleSlider} from "./modules/scheduleSlider";
import {heroBgSlider} from "./modules/heroBgSlider";
import {connatixVideo} from "./modules/connatixVideo";
import {scrollToUploads} from "./modules/scrollToUploads";


binder({
    bounds: {
        "html": [constants],
        "body": [customSelect],
        ".header": header,
        ".subscribe-form-manage": checkedAllFunction,
        ".has-animation": animationOnScroll,
        ".article-slider": articleSlider,
        ".accordion": accordion,
        "[data-goto-anchor]": goToAnchor,
        ".video-slider": videoSlider,
        ".series-video-slider": seriesVideoSlider,
        ".buffer-link": bufferLink,
        ".open-close": openClose,
        ".picture-slider": pictureSlider,
        ".tabset": tabFunction,
        ".view-more-holder": viewMoreFunction,
        ".popup-link": popups,
        ".gallery": gallerySlider,
        ".schedule-slider": scheduleSlider,
        ".hero-bg-slider": heroBgSlider,
        ".leadership-section": scrollToUploads,
        // ".connatix": connatixVideo,hero-connatix
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js